import { UnavailabilityError } from 'expo-modules-core';

export default function AdMediaView() {
  throw new UnavailabilityError('expo-ads-facebook', 'AdMediaView');
}
